import type { ImageLoaderProps } from 'next/image';
import { imageDeliveryUrl } from './imageDelivery.mjs';

const imageLoader = ({ src, width, quality }: ImageLoaderProps) =>
  imageDeliveryUrl({
    src,
    width,
    quality,
    mode: process.env.NEXT_PUBLIC_IMAGE_DELIVERY,
  });

export default imageLoader;
